import {getDataWithPromise} from "root/DataFunctions/BaseDataFns";
import {Globals} from "root/globals";
import { handleAjaxError } from './ErrorHandlingFunctions'

export const doRegister = ( newpass, token, onComplete ) =>
{
    const url = Globals.APIFolder + '/register'

    const data = {
        password: newpass,
        token: token
    } ;

    getDataWithPromise ( url, 'POST', data )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const doPasswordReset = ( username, establishment, onComplete ) =>
{
    const url = Globals.APIFolder + '/resetpassword'

    const data = {
        inpUsername: username,
        inpEstablishmentNumber: establishment
    } ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const doRegisterInterest = ( registrationData, onComplete ) =>
{
    const url = Globals.APIFolder + '/interest'

    getDataWithPromise ( url, 'POST', registrationData )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const setPrivacyRead = ( onComplete ) =>
{
    const url = Globals.APIFolder + '/users/self/privacy_ack' ;

    getDataWithPromise ( url, 'PUT', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const submitChangePassword = ( userid, newpass, onComplete ) =>
{
    const url = Globals.APIFolder + '/users/' + userid+ '/changepassword/' + newpass ;

    getDataWithPromise ( url, 'PUT', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const changeCurrentUserPasswordWithPromise = ( oldpass, newpass, onComplete ) =>
{
    const url = Globals.APIFolder + '/changepassword' ;

    let data = { oldpassword: oldpass, password: newpass } ;

    return getDataWithPromise ( url, 'PUT', { data }, true ) ;
}